//----------------------------------------------------------------------------------------------------------------------
// Version utility for SAGE
//----------------------------------------------------------------------------------------------------------------------

declare const __APP_VERSION__ : string;

export const VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev';

//----------------------------------------------------------------------------------------------------------------------
